import React from 'react'
import './EquipmentListingPage.css'
import '../OemDetails/OemDetails.css'
import { ListingForm } from './ListingForm'
import GuidelinesComponent from './GuidlinesComponent'
export const EquipmentListingPage = () => {
    return (
        <div className="listingContainer">
            <div className="listingInfo">
                <div className="listingForm getInTouchInput ">
                    <ListingForm />
                </div>
            </div>
            <GuidelinesComponent />
        </div>
    )
}
